// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"128":"697f4a948fa8a724","651":"60a192374d46ce2e","893":"55b707972d3f85b4"}[chunkId] + ".js";
};